
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/study-groups/current-topic",
      function () {
        return require("private-next-pages/community/study-groups/current-topic.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/study-groups/current-topic"])
      });
    }
  